import React, {useEffect} from 'react'
import {useLocation, Navigate} from 'react-router-dom'
import apiLink from '../../config'

import Entete from '../MEP/entete' 
import OADMenu from '../MEP/oadMenu'
import ButtonQuestions from '../MEP/button question'
import GraphAleas2 from './Graphiques/graphAleas_2'
import GraphAleasNBjours from './Graphiques/graphAleasNbjours'
import GraphAleasNBjours2 from './Graphiques/graphAleasNbjours2'

import BleT from '../../assets/blé-tendre.png'
import BleD from '../../assets/blé-dur.png'
import Orge from '../../assets/orge.png'
import Mais from '../../assets/maïs.png'
import Colza from '../../assets/colza.png'
import Viti from '../../assets/viti.png'
import Betterave from '../../assets/betterave.png'
import Chanvre from '../../assets/chanvre.png'
import Feverole from '../../assets/feverol.png'
import Luzerne from '../../assets/luzerne.png'
import PdT from '../../assets/pdt.png'
import Pois from '../../assets/pois_prot.png'
import Soja from '../../assets/soja.png'
import Tournesol from '../../assets/tournesol.png'
import CultureNone from '../../assets/cultureNONE.png'

import loading_Data from '../../assets/loading-Data.gif'
import SH_ac from '../../assets/navig2050_SH_ac.png'
import EE_ac from '../../assets/navig2050_exceseau_ac.png'
import GEL_ac from '../../assets/navig2050_gel_ac.png'
import CDC_ac from '../../assets/navig2050_cdcl_ac.png'
import MR_ac from '../../assets/navig2050_manque_rayonnementl_ac.png'
import Podium_ac from '../../assets/navig2050_podium_ac.png'

import SH_inac from '../../assets/navig2050_SH_inac.png'
import EE_inac from '../../assets/navig2050_exceseau_inac.png'
import GEL_inac from '../../assets/navig2050_gel_inac.png'
import CDC_inac from '../../assets/navig2050_cdcl_inac.png'
import MR_inac from '../../assets/navig2050_manque_rayonnementl_inac.png'
import Podium_inac from '../../assets/navig2050_podium_inac.png'

function Aleas() {
  const { state } = useLocation();
  const { idExploit } = state;
  const [CityName, setCityName] = React.useState("")
  const [libellPRA, setLibellePRA] = React.useState("")
  const [BSH, setBSH] = React.useState(false)
  const [BEE, setBEE] = React.useState(false)
  const [BGEL, setBGEL] = React.useState(false)
  const [BCDC, setBCDC] = React.useState(false)
  const [BPodium, setBPodium] = React.useState(true)
  const [BMR, setBMR] = React.useState(false)
  const [BCou, setBCou]= React.useState('UnChecked')
  const [BExc, setBExc]= React.useState('Checked')
  const [BCat, setBCat]= React.useState('UnChecked')
  const [B2d, setB2d]= React.useState('Checked')
  const [B4d, setB4d]= React.useState('UnChecked')
  const [TypeValeur, setTypeValeur] = React.useState('Valeur')
  const [TypeCulture, setTypeCulture] = React.useState("none")
  const [Assol, setAssol]= React.useState();
  

  const [dataMoy_SH_2D, setDataMoy_SH_2D] =  React.useState()
  const [dataMoy_SH_4D, setDataMoy_SH_4D] =  React.useState()
  const [dataMin_SH_2D, setDataMin_SH_2D] =  React.useState()
  const [dataMin_SH_4D, setDataMin_SH_4D] =  React.useState()
  const [dataMax_SH_2D, setDataMax_SH_2D] =  React.useState()
  const [dataMax_SH_4D, setDataMax_SH_4D] =  React.useState()
  const [dataQ1_SH_2D, setDataQ1_SH_2D] =  React.useState()
  const [dataQ1_SH_4D, setDataQ1_SH_4D] =  React.useState()
  const [dataQ3_SH_2D, setDataQ3_SH_2D] =  React.useState()
  const [dataQ3_SH_4D, setDataQ3_SH_4D] =  React.useState()
  const [dataMoy_EE_2D, setDataMoy_EE_2D] =  React.useState()
  const [dataMoy_EE_4D, setDataMoy_EE_4D] =  React.useState()
  const [dataMin_EE_2D, setDataMin_EE_2D] =  React.useState()
  const [dataMin_EE_4D, setDataMin_EE_4D] =  React.useState()
  const [dataMax_EE_2D, setDataMax_EE_2D] =  React.useState()
  const [dataMax_EE_4D, setDataMax_EE_4D] =  React.useState()
  const [dataQ1_EE_2D, setDataQ1_EE_2D] =  React.useState()
  const [dataQ1_EE_4D, setDataQ1_EE_4D] =  React.useState()
  const [dataQ3_EE_2D, setDataQ3_EE_2D] =  React.useState()
  const [dataQ3_EE_4D, setDataQ3_EE_4D] =  React.useState()
  const [dataMoy_GEL_2D, setDataMoy_GEL_2D] =  React.useState()
  const [dataMoy_GEL_4D, setDataMoy_GEL_4D] =  React.useState()
  const [dataMin_GEL_2D, setDataMin_GEL_2D] =  React.useState()
  const [dataMin_GEL_4D, setDataMin_GEL_4D] =  React.useState()
  const [dataMax_GEL_2D, setDataMax_GEL_2D] =  React.useState()
  const [dataMax_GEL_4D, setDataMax_GEL_4D] =  React.useState()
  const [dataQ1_GEL_2D, setDataQ1_GEL_2D] =  React.useState()
  const [dataQ1_GEL_4D, setDataQ1_GEL_4D] =  React.useState()
  const [dataQ3_GEL_2D, setDataQ3_GEL_2D] =  React.useState()
  const [dataQ3_GEL_4D, setDataQ3_GEL_4D] =  React.useState()
  const [dataMoy_CDC_2D, setDataMoy_CDC_2D] =  React.useState()
  const [dataMoy_CDC_4D, setDataMoy_CDC_4D] =  React.useState()
  const [dataMin_CDC_2D, setDataMin_CDC_2D] =  React.useState()
  const [dataMin_CDC_4D, setDataMin_CDC_4D] =  React.useState()
  const [dataMax_CDC_2D, setDataMax_CDC_2D] =  React.useState()
  const [dataMax_CDC_4D, setDataMax_CDC_4D] =  React.useState()
  const [dataQ1_CDC_2D, setDataQ1_CDC_2D] =  React.useState()
  const [dataQ1_CDC_4D, setDataQ1_CDC_4D] =  React.useState()
  const [dataQ3_CDC_2D, setDataQ3_CDC_2D] =  React.useState()
  const [dataQ3_CDC_4D, setDataQ3_CDC_4D] =  React.useState()

  const [dataNbjours_SH_2D, setdataNbjours_SH_2D] = React.useState()
  const [dataNbjours_SH_4D, setdataNbjours_SH_4D] = React.useState()
  const [dataNbjours_EE_2D, setdataNbjours_EE_2D] = React.useState()
  const [dataNbjours_EE_4D, setdataNbjours_EE_4D] = React.useState()
  const [dataNbjours_GEL_2D, setdataNbjours_GEL_2D] = React.useState()
  const [dataNbjours_GEL_4D, setdataNbjours_GEL_4D] = React.useState()
  const [dataNbjours_CDC_2D, setdataNbjours_CDC_2D] = React.useState()
  const [dataNbjours_CDC_4D, setdataNbjours_CDC_4D] = React.useState()
  const [dataNbjoursMin_SH_2D, setdataNbjoursMin_SH_2D] = React.useState()
  const [dataNbjoursMin_SH_4D, setdataNbjoursMin_SH_4D] = React.useState()
  const [dataNbjoursMin_EE_2D, setdataNbjoursMin_EE_2D] = React.useState()
  const [dataNbjoursMin_EE_4D, setdataNbjoursMin_EE_4D] = React.useState()
  const [dataNbjoursMin_GEL_2D, setdataNbjoursMin_GEL_2D] = React.useState()
  const [dataNbjoursMin_GEL_4D, setdataNbjoursMin_GEL_4D] = React.useState()
  const [dataNbjoursMin_CDC_2D, setdataNbjoursMin_CDC_2D] = React.useState()
  const [dataNbjoursMin_CDC_4D, setdataNbjoursMin_CDC_4D] = React.useState()
  const [dataNbjoursMax_SH_2D, setdataNbjoursMax_SH_2D] = React.useState()
  const [dataNbjoursMax_SH_4D, setdataNbjoursMax_SH_4D] = React.useState()
  const [dataNbjoursMax_EE_2D, setdataNbjoursMax_EE_2D] = React.useState()
  const [dataNbjoursMax_EE_4D, setdataNbjoursMax_EE_4D] = React.useState()
  const [dataNbjoursMax_GEL_2D, setdataNbjoursMax_GEL_2D] = React.useState()
  const [dataNbjoursMax_GEL_4D, setdataNbjoursMax_GEL_4D] = React.useState()
  const [dataNbjoursMax_CDC_2D, setdataNbjoursMax_CDC_2D] = React.useState()
  const [dataNbjoursMax_CDC_4D, setdataNbjoursMax_CDC_4D] = React.useState()


  const [aleas, setaleas] = React.useState('SH')
  const [dataMin, setDataMin] = React.useState()
  const [dataQ1, setDataQ1] = React.useState()
  const [dataMoy, setDataMoy] = React.useState()
  const [dataQ3, setDataQ3] = React.useState()
  const [dataMax, setDataMax] = React.useState()
  const [dataNbjoursMoy, setdataNbjoursMoy] = React.useState()
  const [dataNbjoursMax, setdataNbjoursMax] = React.useState()
  const [dataNbjoursMin, setdataNbjoursMin] = React.useState()

  const [ANNEE, setANNEE]= React.useState('2035');
  const [RCP, setRCP]= React.useState('4.5');
  const [RISQUE, setRISQUE]= React.useState('Exc');
  const [dataPodiumC, setDataPodiumC]= React.useState()
  const [dataPodiumA, setDataPodiumA]= React.useState();
  const [dataPodiumCA, setDataPodiumCA]= React.useState();

  function fetchData() {
    fetch('https://api2050.diagorisk.com/pageAleas/?idExploitation=' + idExploit + '&idProduction=' + TypeCulture)
      .then((response) => response.json())
      .then((response) => {
        if ('error' in response) {
          // Si la réponse contient une erreur, relancer la requête après 60 secondes
          setTimeout(fetchData, 60000);
        } else {
          // Si la réponse est réussie, mettre à jour les données
          setDataMoy_SH_2D(response.dataMoy_SH_2D)
          setDataMoy_SH_2D(prev => {
            setDataMoy(prev)
            return prev;
          })
          setDataMoy_SH_4D(response.dataMoy_SH_4D)
          setDataMoy_SH_4D(prev => {
            return prev;
          })
          setDataMin_SH_2D(response.dataMin_SH_2D)
          setDataMin_SH_2D(prev => {
            setDataMin(prev)
            return prev;
          })
          setDataMin_SH_4D(response.dataMin_SH_4D)
          setDataMin_SH_4D(prev => {
            return prev;
          })
          setDataMax_SH_2D(response.dataMax_SH_2D)
          setDataMax_SH_2D(prev => {
            setDataMax(prev)
            return prev;
          })
          setDataMax_SH_4D(response.dataMax_SH_4D)
          setDataMax_SH_4D(prev => {
            return prev;
          })
          setDataQ1_SH_2D(response.dataQ1_SH_2D)
          setDataQ1_SH_2D(prev => {
            setDataQ1(prev)
            return prev;
          })
          setDataQ1_SH_4D(response.dataQ1_SH_4D)
          setDataQ1_SH_4D(prev => {
            return prev;
          })
          setDataQ3_SH_2D(response.dataQ3_SH_2D)
          setDataQ3_SH_2D(prev => {
            setDataQ3(prev)
            return prev;
          })
          setDataQ3_SH_4D(response.dataQ3_SH_4D)
          setDataQ3_SH_4D(prev => {
            return prev;
          })
          setDataMoy_EE_2D(response.dataMoy_EE_2D)
          setDataMoy_EE_2D(prev => {
            return prev;
          })
          setDataMoy_EE_4D(response.dataMoy_EE_4D)
          setDataMoy_EE_4D(prev => {
            return prev;
          })
          setDataMin_EE_2D(response.dataMin_EE_2D)
          setDataMin_EE_2D(prev => {
            return prev;
          })
          setDataMin_EE_4D(response.dataMin_EE_4D)
          setDataMin_EE_4D(prev => {
            return prev;
          })
          setDataMax_EE_2D(response.dataMax_EE_2D)
          setDataMax_EE_2D(prev => {
            return prev;
          })
          setDataMax_EE_4D(response.dataMax_EE_4D)
          setDataMax_EE_4D(prev => {
            return prev;
          })
          setDataQ1_EE_2D(response.dataQ1_EE_2D)
          setDataQ1_EE_2D(prev => {
            return prev;
          })
          setDataQ1_EE_4D(response.dataQ1_EE_4D)
          setDataQ1_EE_4D(prev => {
            return prev;
          })
          setDataQ3_EE_2D(response.dataQ3_EE_2D)
          setDataQ3_EE_2D(prev => {
            return prev;
          })
          setDataQ3_EE_4D(response.dataQ3_EE_4D)
          setDataQ3_EE_4D(prev => {
            return prev;
          })
          setDataMoy_GEL_2D(response.dataMoy_GEL_2D)
          setDataMoy_GEL_2D(prev => {
            return prev;
          })
          setDataMoy_GEL_4D(response.dataMoy_GEL_4D)
          setDataMoy_GEL_4D(prev => {
            return prev;
          })
          setDataMin_GEL_2D(response.dataMin_GEL_2D)
          setDataMin_GEL_2D(prev => {
            return prev;
          })
          setDataMin_GEL_4D(response.dataMin_GEL_4D)
          setDataMin_GEL_4D(prev => {
            return prev;
          })
          setDataMax_GEL_2D(response.dataMax_GEL_2D)
          setDataMax_GEL_2D(prev => {
            return prev;
          })
          setDataMax_GEL_4D(response.dataMax_GEL_4D)
          setDataMax_GEL_4D(prev => {
            return prev;
          })
          setDataQ1_GEL_2D(response.dataQ1_GEL_2D)
          setDataQ1_GEL_2D(prev => {
            return prev;
          })
          setDataQ1_GEL_4D(response.dataQ1_GEL_4D)
          setDataQ1_GEL_4D(prev => {
            return prev;
          })
          setDataQ3_GEL_2D(response.dataQ3_GEL_2D)
          setDataQ3_GEL_2D(prev => {
            return prev;
          })
          setDataQ3_GEL_4D(response.dataQ3_GEL_4D)
          setDataQ3_GEL_4D(prev => {
            return prev;
          })
          setDataMoy_CDC_2D(response.dataMoy_CDC_2D)
          setDataMoy_CDC_2D(prev => {
            return prev;
          })
          setDataMoy_CDC_4D(response.dataMoy_CDC_4D)
          setDataMoy_CDC_4D(prev => {
            return prev;
          })
          setDataMin_CDC_2D(response.dataMin_CDC_2D)
          setDataMin_CDC_2D(prev => {
            return prev;
          })
          setDataMin_CDC_4D(response.dataMin_CDC_4D)
          setDataMin_CDC_4D(prev => {
            return prev;
          })
          setDataMax_CDC_2D(response.dataMax_CDC_2D)
          setDataMax_CDC_2D(prev => {
            return prev;
          })
          setDataMax_CDC_4D(response.dataMax_CDC_4D)
          setDataMax_CDC_4D(prev => {
            return prev;
          })
          setDataQ1_CDC_2D(response.dataQ1_CDC_2D)
          setDataQ1_CDC_2D(prev => {
            return prev;
          })
          setDataQ1_CDC_4D(response.dataQ1_CDC_4D)
          setDataQ1_CDC_4D(prev => {
            return prev;
          })
          setDataQ3_CDC_2D(response.dataQ3_CDC_2D)
          setDataQ3_CDC_2D(prev => {
            return prev;
          })
          setDataQ3_CDC_4D(response.dataQ3_CDC_4D)
          setDataQ3_CDC_4D(prev => {
            return prev;
          })
          setdataNbjours_SH_2D(response.dataNbjours_SH_2D)
          setdataNbjours_SH_2D(prev => {
            setdataNbjoursMoy(prev)
            return prev;
          })
          setdataNbjours_SH_4D(response.dataNbjours_SH_4D)
          setdataNbjours_SH_4D(prev => {
            return prev;
          })
          setdataNbjours_EE_2D(response.dataNbjours_EE_2D)
          setdataNbjours_EE_2D(prev => {
            return prev;
          })
          setdataNbjours_EE_4D(response.dataNbjours_EE_4D)
          setdataNbjours_EE_4D(prev => {
            return prev;
          })
          setdataNbjours_GEL_2D(response.dataNbjours_GEL_2D)
          setdataNbjours_GEL_2D(prev => {
            return prev;
          })
          setdataNbjours_GEL_4D(response.dataNbjours_GEL_4D)
          setdataNbjours_GEL_4D(prev => {
            return prev;
          })
          setdataNbjours_CDC_2D(response.dataNbjours_CDC_2D)
          setdataNbjours_CDC_2D(prev => {
            return prev;
          })
          setdataNbjours_CDC_4D(response.dataNbjours_CDC_4D)
          setdataNbjours_CDC_4D(prev => {
            return prev;
          })
          setdataNbjoursMax_SH_2D(response.dataNbjoursMax_SH_2D)
          setdataNbjoursMax_SH_2D(prev => {
            setdataNbjoursMax(prev)
            return prev;
          })
          setdataNbjoursMax_SH_4D(response.dataNbjoursMax_SH_4D)
          setdataNbjoursMax_SH_4D(prev => {
            return prev;
          })
          setdataNbjoursMax_EE_2D(response.dataNbjoursMax_EE_2D)
          setdataNbjoursMax_EE_2D(prev => {
            return prev;
          })
          setdataNbjoursMax_EE_4D(response.dataNbjoursMax_EE_4D)
          setdataNbjoursMax_EE_4D(prev => {
            return prev;
          })
          setdataNbjoursMax_GEL_2D(response.dataNbjoursMax_GEL_2D)
          setdataNbjoursMax_GEL_2D(prev => {
            return prev;
          })
          setdataNbjoursMax_GEL_4D(response.dataNbjoursMax_GEL_4D)
          setdataNbjoursMax_GEL_4D(prev => {
            return prev;
          })
          setdataNbjoursMax_CDC_2D(response.dataNbjoursMax_CDC_2D)
          setdataNbjoursMax_CDC_2D(prev => {
            return prev;
          })
          setdataNbjoursMax_CDC_4D(response.dataNbjoursMax_CDC_4D)
          setdataNbjoursMax_CDC_4D(prev => {
            return prev;
          })
          setdataNbjoursMin_SH_2D(response.dataNbjoursMin_SH_2D)
          setdataNbjoursMin_SH_2D(prev => {
            setdataNbjoursMin(prev)
            return prev;
          })
          setdataNbjoursMin_SH_4D(response.dataNbjoursMin_SH_4D)
          setdataNbjoursMin_SH_4D(prev => {
            return prev;
          })
          setdataNbjoursMin_EE_2D(response.dataNbjoursMin_EE_2D)
          setdataNbjoursMin_EE_2D(prev => {
            return prev;
          })
          setdataNbjoursMin_EE_4D(response.dataNbjoursMin_EE_4D)
          setdataNbjoursMin_EE_4D(prev => {
            return prev;
          })
          setdataNbjoursMin_GEL_2D(response.dataNbjoursMin_GEL_2D)
          setdataNbjoursMin_GEL_2D(prev => {
            return prev;
          })
          setdataNbjoursMin_GEL_4D(response.dataNbjoursMin_GEL_4D)
          setdataNbjoursMin_GEL_4D(prev => {
            return prev;
          })
          setdataNbjoursMin_CDC_2D(response.dataNbjoursMin_CDC_2D)
          setdataNbjoursMin_CDC_2D(prev => {
            return prev;
          })
          setdataNbjoursMin_CDC_4D(response.dataNbjoursMin_CDC_4D)
          setdataNbjoursMin_CDC_4D(prev => {
            return prev;
          })
        }
      })
      .catch((error) => {
        // Gérer les erreurs de la requête
        console.error('Erreur lors de la requête API :', error);
      });
  }

  useEffect ( () => {
      fetch(apiLink + 'getLocalisation/' + idExploit)
      .then( (response) => {
        return response.json()
      })
      .then(response =>{
          var city =  response.idCommune
          fetch(apiLink + 'getCommune/' + city )
          .then( (response) => {
          return response.json()
          })
          .then(response =>{
          setLibellePRA(response.libellePetiteRegionAgricole)
          setLibellePRA(prev => {
              return prev;
          })
          var cp = response.codePostal
          var libellecity = response.libelleCommune
          setCityName(cp + ' - ' + libellecity)
          setCityName(prev => {
              return prev;
          })
          })
      }) 
      fetchData()
      fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=2035&Rcp=4.5&Risque=Exc') 
      .then((response) => response.json())
      .then((response) => {
        setDataPodiumA(response.dataPodiumA)
        setDataPodiumA(prev => {
          return prev;
        })
        setDataPodiumC(response.dataPodiumC)
        setDataPodiumC(prev => {
          return prev;
        })
        setDataPodiumCA(response.dataPodiumCA)
        setDataPodiumCA(prev => {
          return prev;
        })
      })
      fetch(apiLink + 'page/production-rapport/' + idExploit)
      .then( (response) => {
        return response.json()
      })
      .then(response =>{
        setAssol(response)
        setAssol(prev => {
          return prev;
        })
      }) 
    }, [idExploit])

  function culturePresente(idProd, assol) { //permet d'activer ou désactiver les productions dans la liste donc si true alors disabled = true et donc la culture n'est pas dans l'assolement
    for (var cle in assol) {
        if (cle.includes(idProd)) {
            return false; // Si l'idProd est trouvé dans une clé, retourne false immédiatement
        }
    }
    return true; // Si aucune clé ne contient idProd, retourne true
  }

  function handleClickSH(){
      setBSH(true)
      setBEE(false)
      setBGEL(false)
      setBCDC(false)
      setBMR(false)
      setBPodium(false)
      setaleas('SH')
      if (B2d === 'Checked'){
        setDataMoy(dataMoy_SH_2D)
        setDataMax(dataMax_SH_2D)
        setDataMin(dataMin_SH_2D)
        setDataQ1(dataQ1_SH_2D)
        setDataQ3(dataQ3_SH_2D)
        setdataNbjoursMoy(dataNbjours_SH_2D)
        setdataNbjoursMin(dataNbjoursMin_SH_2D)
        setdataNbjoursMax(dataNbjoursMax_SH_2D)
      }
      else {
        setDataMoy(dataMoy_SH_4D)
        setDataMax(dataMax_SH_4D)
        setDataMin(dataMin_SH_4D)
        setDataQ1(dataQ1_SH_4D)
        setDataQ3(dataQ3_SH_4D)
        setdataNbjoursMoy(dataNbjours_SH_4D)
        setdataNbjoursMin(dataNbjoursMin_SH_4D)
        setdataNbjoursMax(dataNbjoursMax_SH_4D)
      }
  }
  function handleClickEE(){
      setBSH(false)
      setBEE(true)
      setBGEL(false)
      setBCDC(false)
      setBMR(false)
      setBPodium(false)
      setaleas('EE')
      if (B2d === 'Checked'){
        setDataMoy(dataMoy_EE_2D)
        setDataMax(dataMax_EE_2D)
        setDataMin(dataMin_EE_2D)
        setDataQ1(dataQ1_EE_2D)
        setDataQ3(dataQ3_EE_2D)
        setdataNbjoursMoy(dataNbjours_EE_2D)
        setdataNbjoursMin(dataNbjoursMin_EE_2D)
        setdataNbjoursMax(dataNbjoursMax_EE_2D)
      }
      else {
        setDataMoy(dataMoy_EE_4D)
        setDataMax(dataMax_EE_4D)
        setDataMin(dataMin_EE_4D)
        setDataQ1(dataQ1_EE_4D)
        setDataQ3(dataQ3_EE_4D)
        setdataNbjoursMoy(dataNbjours_EE_4D)
        setdataNbjoursMin(dataNbjoursMin_EE_4D)
        setdataNbjoursMax(dataNbjoursMax_EE_4D)
      }
  }
  function handleClickGEL(){
      setBSH(false)
      setBEE(false)
      setBGEL(true)
      setBCDC(false)
      setBMR(false)
      setBPodium(false)
      setaleas('GEL')
      if (B2d === 'Checked'){
        setDataMoy(dataMoy_GEL_2D)
        setDataMax(dataMax_GEL_2D)
        setDataMin(dataMin_GEL_2D)
        setDataQ1(dataQ1_GEL_2D)
        setDataQ3(dataQ3_GEL_2D)
        setdataNbjoursMoy(dataNbjours_GEL_2D)
        setdataNbjoursMin(dataNbjoursMin_GEL_2D)
        setdataNbjoursMax(dataNbjoursMax_GEL_2D)
      }
      else {
        setDataMoy(dataMoy_GEL_4D)
        setDataMax(dataMax_GEL_4D)
        setDataMin(dataMin_GEL_4D)
        setDataQ1(dataQ1_GEL_4D)
        setDataQ3(dataQ3_GEL_4D)
        setdataNbjoursMoy(dataNbjours_GEL_4D)
        setdataNbjoursMin(dataNbjoursMin_GEL_4D)
        setdataNbjoursMax(dataNbjoursMax_GEL_4D)
      }
  }
  function handleClickCDC(){
      setBSH(false)
      setBEE(false)
      setBGEL(false)
      setBCDC(true)
      setBMR(false)
      setBPodium(false)
      setaleas('CDC')
      if (B2d === 'Checked'){
        setDataMoy(dataMoy_CDC_2D)
        setDataMax(dataMax_CDC_2D)
        setDataMin(dataMin_CDC_2D)
        setDataQ1(dataQ1_CDC_2D)
        setDataQ3(dataQ3_CDC_2D)
        setdataNbjoursMoy(dataNbjours_CDC_2D)
        setdataNbjoursMin(dataNbjoursMin_CDC_2D)
        setdataNbjoursMax(dataNbjoursMax_CDC_2D)
      }
      else {
        setDataMoy(dataMoy_CDC_4D)
        setDataMax(dataMax_CDC_4D)
        setDataMin(dataMin_CDC_4D)
        setDataQ1(dataQ1_CDC_4D)
        setDataQ3(dataQ3_CDC_4D)
        setdataNbjoursMoy(dataNbjours_CDC_4D)
        setdataNbjoursMin(dataNbjoursMin_CDC_4D)
        setdataNbjoursMax(dataNbjoursMax_CDC_4D)
      }
  }
  function handleClickMR(){
  }
  function SwitchDataType(){
    if (TypeValeur === "Valeur"){
      setTypeValeur('Diff')
    }
    else {
      setTypeValeur('Valeur')
    }
    
  }
  function handleClickPodium(){
    setBSH(false)
    setBEE(false)
    setBGEL(false)
    setBCDC(false)
    setBMR(false)
    setBPodium(true)
  }
  function handlePressCourant() {
    setBCou('Checked')
    setBExc('UnChecked')
    setBCat('UnChecked')
    setRISQUE('Co')
    fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=' + ANNEE +'&Rcp=' + RCP + '&Risque=Co') 
      .then((response) => response.json())
      .then((response) => {
        setDataPodiumA(response.dataPodiumA)
        setDataPodiumA(prev => {
          return prev;
        })
        setDataPodiumC(response.dataPodiumC)
        setDataPodiumC(prev => {
          return prev;
        })
        setDataPodiumCA(response.dataPodiumCA)
        setDataPodiumCA(prev => {
          return prev;
        })
      })
  }
  function handlePressExceptionnel() {
    setBExc('Checked')
    setBCou('UnChecked')
    setBCat('UnChecked')
    setRISQUE('Exc')
    fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=' + ANNEE +'&Rcp=' + RCP + '&Risque=Exc') 
      .then((response) => response.json())
      .then((response) => {
        setDataPodiumA(response.dataPodiumA)
        setDataPodiumA(prev => {
          return prev;
        })
        setDataPodiumC(response.dataPodiumC)
        setDataPodiumC(prev => {
          return prev;
        })
        setDataPodiumCA(response.dataPodiumCA)
        setDataPodiumCA(prev => {
          return prev;
        })
      })
  }
  function handlePressCatastrophique() {
    setBCat('Checked')
    setBCou('UnChecked')
    setBExc('UnChecked')
    setRISQUE('Ca')
    fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=' + ANNEE +'&Rcp=' + RCP + '&Risque=Ca') 
      .then((response) => response.json())
      .then((response) => {
        setDataPodiumA(response.dataPodiumA)
        setDataPodiumA(prev => {
          return prev;
        })
        setDataPodiumC(response.dataPodiumC)
        setDataPodiumC(prev => {
          return prev;
        })
        setDataPodiumCA(response.dataPodiumCA)
        setDataPodiumCA(prev => {
          return prev;
        })
      })
    
  }
  function handleB2D(){
    setB2d("Checked")
    setB4d("UnChecked")
    setRCP('4.5')
    fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=' + ANNEE +'&Rcp=4.5&Risque=' + RISQUE) 
      .then((response) => response.json())
      .then((response) => {
        setDataPodiumA(response.dataPodiumA)
        setDataPodiumA(prev => {
          return prev;
        })
        setDataPodiumC(response.dataPodiumC)
        setDataPodiumC(prev => {
          return prev;
        })
        setDataPodiumCA(response.dataPodiumCA)
        setDataPodiumCA(prev => {
          return prev;
        })
      })
      if (aleas === 'SH'){
        setDataMoy(dataMoy_SH_2D)
        setDataMax(dataMax_SH_2D)
        setDataMin(dataMin_SH_2D)
        setDataQ1(dataQ1_SH_2D)
        setDataQ3(dataQ3_SH_2D)
        setdataNbjoursMoy(dataNbjours_SH_2D)
        setdataNbjoursMin(dataNbjoursMin_SH_2D)
        setdataNbjoursMax(dataNbjoursMax_SH_2D)
      }
      else if (aleas === 'EE'){
        setDataMoy(dataMoy_EE_2D)
        setDataMax(dataMax_EE_2D)
        setDataMin(dataMin_EE_2D)
        setDataQ1(dataQ1_EE_2D)
        setDataQ3(dataQ3_EE_2D)
        setdataNbjoursMoy(dataNbjours_EE_2D)
        setdataNbjoursMin(dataNbjoursMin_EE_2D)
        setdataNbjoursMax(dataNbjoursMax_EE_2D)
      }
      else if (aleas === 'GEL'){
        setDataMoy(dataMoy_GEL_2D)
        setDataMax(dataMax_GEL_2D)
        setDataMin(dataMin_GEL_2D)
        setDataQ1(dataQ1_GEL_2D)
        setDataQ3(dataQ3_GEL_2D)
        setdataNbjoursMoy(dataNbjours_GEL_2D)
        setdataNbjoursMin(dataNbjoursMin_GEL_2D)
        setdataNbjoursMax(dataNbjoursMax_GEL_2D)
      }
      else {
        setDataMoy(dataMoy_CDC_2D)
        setDataMax(dataMax_CDC_2D)
        setDataMin(dataMin_CDC_2D)
        setDataQ1(dataQ1_CDC_2D)
        setDataQ3(dataQ3_CDC_2D)
        setdataNbjoursMoy(dataNbjours_CDC_2D)
        setdataNbjoursMin(dataNbjoursMin_CDC_2D)
        setdataNbjoursMax(dataNbjoursMax_CDC_2D)
      }
  }
  function handleB4D(){
    setB2d("UnChecked")
    setB4d("Checked")
    setRCP('8.5')
    fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=' + ANNEE +'&Rcp=8.5&Risque=' + RISQUE) 
    .then((response) => response.json())
    .then((response) => {
      setDataPodiumA(response.dataPodiumA)
      setDataPodiumA(prev => {
        return prev;
      })
      setDataPodiumC(response.dataPodiumC)
      setDataPodiumC(prev => {
        return prev;
      })
      setDataPodiumCA(response.dataPodiumCA)
      setDataPodiumCA(prev => {
        return prev;
      })
    })
    if (aleas === 'SH'){
      setDataMoy(dataMoy_SH_4D)
      setDataMax(dataMax_SH_4D)
      setDataMin(dataMin_SH_4D)
      setDataQ1(dataQ1_SH_4D)
      setDataQ3(dataQ3_SH_4D)
      setdataNbjoursMoy(dataNbjours_SH_4D)
      setdataNbjoursMin(dataNbjoursMin_SH_4D)
      setdataNbjoursMax(dataNbjoursMax_SH_4D)
    }
    else if (aleas === 'EE'){
      setDataMoy(dataMoy_EE_4D)
      setDataMax(dataMax_EE_4D)
      setDataMin(dataMin_EE_4D)
      setDataQ1(dataQ1_EE_4D)
      setDataQ3(dataQ3_EE_4D)
      setdataNbjoursMoy(dataNbjours_EE_4D)
      setdataNbjoursMin(dataNbjoursMin_EE_4D)
      setdataNbjoursMax(dataNbjoursMax_EE_4D)
    }
    else if (aleas === 'GEL'){
      setDataMoy(dataMoy_GEL_4D)
      setDataMax(dataMax_GEL_4D)
      setDataMin(dataMin_GEL_4D)
      setDataQ1(dataQ1_GEL_4D)
      setDataQ3(dataQ3_GEL_4D)
      setdataNbjoursMoy(dataNbjours_GEL_4D)
      setdataNbjoursMin(dataNbjoursMin_GEL_4D)
      setdataNbjoursMax(dataNbjoursMax_GEL_4D)
    }
    else {
      setDataMoy(dataMoy_CDC_4D)
      setDataMax(dataMax_CDC_4D)
      setDataMin(dataMin_CDC_4D)
      setDataQ1(dataQ1_CDC_4D)
      setDataQ3(dataQ3_CDC_4D)
      setdataNbjoursMoy(dataNbjours_CDC_4D)
      setdataNbjoursMin(dataNbjoursMin_CDC_4D)
      setdataNbjoursMax(dataNbjoursMax_CDC_4D)
    }
  }
  
  function handleChangeTypeCulture(event) {
    setDataMoy(undefined)
    setDataMax(undefined)
    setDataMin(undefined)
    setDataQ1(undefined)
    setDataQ3(undefined)
    var TC = event.target.value;
    setTypeCulture(TC)
    fetch('https://api2050.diagorisk.com/pageAleas/?idExploitation=' + idExploit + '&idProduction=' + TC)
    .then((response) => response.json())
    .then((response) => {
    // Si la réponse est réussie, mettre à jour les données
    setDataMoy_SH_2D(response.dataMoy_SH_2D)
    setDataMoy_SH_2D(prev => {
        if (B2d === 'Checked' && BSH){
          setDataMoy(prev)
        }
        return prev;
    })
    setDataMoy_SH_4D(response.dataMoy_SH_4D)
    setDataMoy_SH_4D(prev => {
      if (B4d === 'Checked' && BSH){
        setDataMoy(prev)
      }
        return prev;
    })
    setDataMin_SH_2D(response.dataMin_SH_2D)
    setDataMin_SH_2D(prev => {
      if (B2d === 'Checked' && BSH){
        setDataMin(prev)
      }
        return prev;
    })
    setDataMin_SH_4D(response.dataMin_SH_4D)
    setDataMin_SH_4D(prev => {
      if (B4d === 'Checked' && BSH){
        setDataMin(prev)
      }
        return prev;
    })
    setDataMax_SH_2D(response.dataMax_SH_2D)
    setDataMax_SH_2D(prev => {
      if (B2d === 'Checked' && BSH){
        setDataMax(prev)
      }
        return prev;
    })
    setDataMax_SH_4D(response.dataMax_SH_4D)
    setDataMax_SH_4D(prev => {
      if (B4d === 'Checked' && BSH){
        setDataMax(prev)
      }
        return prev;
    })
    setDataQ1_SH_2D(response.dataQ1_SH_2D)
    setDataQ1_SH_2D(prev => {
      if (B2d === 'Checked' && BSH){
        setDataQ1(prev)
      }
        return prev;
    })
    setDataQ1_SH_4D(response.dataQ1_SH_4D)
    setDataQ1_SH_4D(prev => {
      if (B4d === 'Checked' && BSH){
        setDataQ1(prev)
      }
        return prev;
    })
    setDataQ3_SH_2D(response.dataQ3_SH_2D)
    setDataQ3_SH_2D(prev => {
      if (B2d === 'Checked' && BSH){
        setDataQ3(prev)
      }
        return prev;
    })
    setDataQ3_SH_4D(response.dataQ3_SH_4D)
    setDataQ3_SH_4D(prev => {
      if (B4d === 'Checked' && BSH){
        setDataQ3(prev)
      }
        return prev;
    })
    setDataMoy_EE_2D(response.dataMoy_EE_2D)
    setDataMoy_EE_2D(prev => {
        if (B2d === 'Checked' && BEE){
          setDataMoy(prev)
        }
        return prev;
    })
    setDataMoy_EE_4D(response.dataMoy_EE_4D)
    setDataMoy_EE_4D(prev => {
      if (B4d === 'Checked' && BEE){
        setDataMoy(prev)
      }
        return prev;
    })
    setDataMin_EE_2D(response.dataMin_EE_2D)
    setDataMin_EE_2D(prev => {
      if (B2d === 'Checked' && BEE){
        setDataMin(prev)
      }
        return prev;
    })
    setDataMin_EE_4D(response.dataMin_EE_4D)
    setDataMin_EE_4D(prev => {
      if (B4d === 'Checked' && BEE){
        setDataMin(prev)
      }
        return prev;
    })
    setDataMax_EE_2D(response.dataMax_EE_2D)
    setDataMax_EE_2D(prev => {
      if (B2d === 'Checked' && BEE){
        setDataMax(prev)
      }
        return prev;
    })
    setDataMax_EE_4D(response.dataMax_EE_4D)
    setDataMax_EE_4D(prev => {
      if (B4d === 'Checked' && BEE){
        setDataMax(prev)
      }
        return prev;
    })
    setDataQ1_EE_2D(response.dataQ1_EE_2D)
    setDataQ1_EE_2D(prev => {
      if (B2d === 'Checked' && BEE){
        setDataQ1(prev)
      }
        return prev;
    })
    setDataQ1_EE_4D(response.dataQ1_EE_4D)
    setDataQ1_EE_4D(prev => {
      if (B4d === 'Checked' && BEE){
        setDataQ1(prev)
      }
        return prev;
    })
    setDataQ3_EE_2D(response.dataQ3_EE_2D)
    setDataQ3_EE_2D(prev => {
      if (B2d === 'Checked' && BEE){
        setDataQ3(prev)
      }
        return prev;
    })
    setDataQ3_EE_4D(response.dataQ3_EE_4D)
    setDataQ3_EE_4D(prev => {
      if (B4d === 'Checked' && BEE){
        setDataQ3(prev)
      }
        return prev;
    })
    setDataMoy_GEL_2D(response.dataMoy_GEL_2D)
    setDataMoy_GEL_2D(prev => {
        if (B2d === 'Checked' && BGEL){
          setDataMoy(prev)
        }
        return prev;
    })
    setDataMoy_GEL_4D(response.dataMoy_GEL_4D)
    setDataMoy_GEL_4D(prev => {
      if (B4d === 'Checked' && BGEL){
        setDataMoy(prev)
      }
        return prev;
    })
    setDataMin_GEL_2D(response.dataMin_GEL_2D)
    setDataMin_GEL_2D(prev => {
      if (B2d === 'Checked' && BGEL){
        setDataMin(prev)
      }
        return prev;
    })
    setDataMin_GEL_4D(response.dataMin_GEL_4D)
    setDataMin_GEL_4D(prev => {
      if (B4d === 'Checked' && BGEL){
        setDataMin(prev)
      }
        return prev;
    })
    setDataMax_GEL_2D(response.dataMax_GEL_2D)
    setDataMax_GEL_2D(prev => {
      if (B2d === 'Checked' && BGEL){
        setDataMax(prev)
      }
        return prev;
    })
    setDataMax_GEL_4D(response.dataMax_GEL_4D)
    setDataMax_GEL_4D(prev => {
      if (B4d === 'Checked' && BGEL){
        setDataMax(prev)
      }
        return prev;
    })
    setDataQ1_GEL_2D(response.dataQ1_GEL_2D)
    setDataQ1_GEL_2D(prev => {
      if (B2d === 'Checked' && BGEL){
        setDataQ1(prev)
      }
        return prev;
    })
    setDataQ1_GEL_4D(response.dataQ1_GEL_4D)
    setDataQ1_GEL_4D(prev => {
      if (B4d === 'Checked' && BGEL){
        setDataQ1(prev)
      }
        return prev;
    })
    setDataQ3_GEL_2D(response.dataQ3_GEL_2D)
    setDataQ3_GEL_2D(prev => {
      if (B2d === 'Checked' && BGEL){
        setDataQ3(prev)
      }
        return prev;
    })
    setDataQ3_GEL_4D(response.dataQ3_GEL_4D)
    setDataQ3_GEL_4D(prev => {
      if (B4d === 'Checked' && BGEL){
        setDataQ3(prev)
      }
        return prev;
    })
    setDataMoy_CDC_2D(response.dataMoy_CDC_2D)
    setDataMoy_CDC_2D(prev => {
        if (B2d === 'Checked' && BCDC){
          setDataMoy(prev)
        }
        return prev;
    })
    setDataMoy_CDC_4D(response.dataMoy_CDC_4D)
    setDataMoy_CDC_4D(prev => {
      if (B4d === 'Checked' && BCDC){
        setDataMoy(prev)
      }
        return prev;
    })
    setDataMin_CDC_2D(response.dataMin_CDC_2D)
    setDataMin_CDC_2D(prev => {
      if (B2d === 'Checked' && BCDC){
        setDataMin(prev)
      }
        return prev;
    })
    setDataMin_CDC_4D(response.dataMin_CDC_4D)
    setDataMin_CDC_4D(prev => {
      if (B4d === 'Checked' && BCDC){
        setDataMin(prev)
      }
        return prev;
    })
    setDataMax_CDC_2D(response.dataMax_CDC_2D)
    setDataMax_CDC_2D(prev => {
      if (B2d === 'Checked' && BCDC){
        setDataMax(prev)
      }
        return prev;
    })
    setDataMax_CDC_4D(response.dataMax_CDC_4D)
    setDataMax_CDC_4D(prev => {
      if (B4d === 'Checked' && BCDC){
        setDataMax(prev)
      }
        return prev;
    })
    setDataQ1_CDC_2D(response.dataQ1_CDC_2D)
    setDataQ1_CDC_2D(prev => {
      if (B2d === 'Checked' && BCDC){
        setDataQ1(prev)
      }
        return prev;
    })
    setDataQ1_CDC_4D(response.dataQ1_CDC_4D)
    setDataQ1_CDC_4D(prev => {
      if (B4d === 'Checked' && BCDC){
        setDataQ1(prev)
      }
        return prev;
    })
    setDataQ3_CDC_2D(response.dataQ3_CDC_2D)
    setDataQ3_CDC_2D(prev => {
      if (B2d === 'Checked' && BCDC){
        setDataQ3(prev)
      }
        return prev;
    })
    setDataQ3_CDC_4D(response.dataQ3_CDC_4D)
    setDataQ3_CDC_4D(prev => {
      if (B4d === 'Checked' && BCDC){
        setDataQ3(prev)
      }
        return prev;
    })
    
  })
  }

  function handleChangeAnneeComp(event){
    var annee = event.target.value
    setANNEE(annee)
    if (annee === '2025'){
      fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=2025&Rcp=' + RCP + '&Risque=' + RISQUE) 
      .then((response) => response.json())
      .then((response) => {
        setDataPodiumA(response.dataPodiumA)
        setDataPodiumA(prev => {
          return prev;
        })
        setDataPodiumC(response.dataPodiumC)
        setDataPodiumC(prev => {
          return prev;
        })
        setDataPodiumCA(response.dataPodiumCA)
        setDataPodiumCA(prev => {
          return prev;
        })
      })
    }
    else if (annee === '2030'){
      fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=2030&Rcp=' + RCP + '&Risque=' + RISQUE) 
      .then((response) => response.json())
      .then((response) => {
        setDataPodiumA(response.dataPodiumA)
        setDataPodiumA(prev => {
          return prev;
        })
        setDataPodiumC(response.dataPodiumC)
        setDataPodiumC(prev => {
          return prev;
        })
        setDataPodiumCA(response.dataPodiumCA)
        setDataPodiumCA(prev => {
          return prev;
        })
      })
    }
    else if (annee === '2035'){
      fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=2035&Rcp=' + RCP + '&Risque=' + RISQUE) 
      .then((response) => response.json())
      .then((response) => {
        setDataPodiumA(response.dataPodiumA)
        setDataPodiumA(prev => {
          return prev;
        })
        setDataPodiumC(response.dataPodiumC)
        setDataPodiumC(prev => {
          return prev;
        })
        setDataPodiumCA(response.dataPodiumCA)
        setDataPodiumCA(prev => {
          return prev;
        })
      })
    }
    else if (annee === '2040'){
      fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=2040&Rcp=' + RCP + '&Risque=' + RISQUE) 
      .then((response) => response.json())
      .then((response) => {
        setDataPodiumA(response.dataPodiumA)
        setDataPodiumA(prev => {
          return prev;
        })
        setDataPodiumC(response.dataPodiumC)
        setDataPodiumC(prev => {
          return prev;
        })
        setDataPodiumCA(response.dataPodiumCA)
        setDataPodiumCA(prev => {
          return prev;
        })
      })
    }
    else if (annee === '2045'){
      fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=2045&Rcp=' + RCP + '&Risque=' + RISQUE) 
      .then((response) => response.json())
      .then((response) => {
        setDataPodiumA(response.dataPodiumA)
        setDataPodiumA(prev => {
          return prev;
        })
        setDataPodiumC(response.dataPodiumC)
        setDataPodiumC(prev => {
          return prev;
        })
        setDataPodiumCA(response.dataPodiumCA)
        setDataPodiumCA(prev => {
          return prev;
        })
      })
    }
    else if (annee === '2050'){
      fetch('https://api2050.diagorisk.com/podiumAleas/?idExploitation=' + idExploit + '&Annee=2050&Rcp=' + RCP + '&Risque=' + RISQUE) 
      .then((response) => response.json())
      .then((response) => {
        setDataPodiumA(response.dataPodiumA)
        setDataPodiumA(prev => {
          return prev;
        })
        setDataPodiumC(response.dataPodiumC)
        setDataPodiumC(prev => {
          return prev;
        })
        setDataPodiumCA(response.dataPodiumCA)
        setDataPodiumCA(prev => {
          return prev;
        })
      })
    }
  }

    return (
        <div>
            <Entete titre="Aléas"/>
            <div className='container'> 
                
                <div  className='containerAleas' style={{marginTop:'-10px'}}> 
                    <div className='titre' style={{textAlign:'center'}}> {BSH ? "Impact du stress hydrique  " : BEE ? " Impact d'un excès d'eau" : BGEL ? " Impact du gel" : BCDC ? "Impact des coups de chaleur ": BMR ? "Impact d'un manque de rayonnement": "Classement des impacts"} toutes productions confondues</div>
                    <div className='paragraphe' style={{textAlign:'center'}}> Commune : <span style={{fontWeight:'bold'}}>{CityName}</span></div>
                    <div className='paragraphe' style={{textAlign:'center'}}> Petite région agricole : <span style={{fontWeight:'bold'}}>{libellPRA}</span></div>
                </div>
                
                <div className='buttonsFixedAleas'> {/*mettre que c'est fixe */}
                    <div className={BPodium ? 'paragraphe ongletaléas_INAC ongletaléas_AC OAléasPodium_AC': 'paragraphe ongletaléas_INAC OAléasPodium_INAC'} onClick={handleClickPodium}> 
                        <img src={BPodium ? Podium_ac: Podium_inac} alt='icone' className={BPodium ? 'ongletLOGOaléas_AC' : 'ongletLOGOaléas_INAC'}/> 
                        {BPodium ? (<div className='paragrapheAleas'>Classement impacts</div>) : ""}
                    </div>
                    <div className={BSH ? 'paragraphe ongletaléas_INAC ongletaléas_AC OAléasSH_AC': 'paragraphe ongletaléas_INAC OAléasSH_INAC'} onClick={handleClickSH}> 
                        <img src={BSH ? SH_ac: SH_inac} alt='icone' className={BSH ? 'ongletLOGOaléas_AC' : 'ongletLOGOaléas_INAC'} /> 
                        {BSH ? (<div className='paragrapheAleas'>Stress hydrique</div>) : ""}
                    </div>
                    <div className={BEE ? 'paragraphe ongletaléas_INAC ongletaléas_AC OAléasEE_AC': 'paragraphe ongletaléas_INAC OAléasEE_INAC'} onClick={handleClickEE}> 
                        <img src={BEE ? EE_ac: EE_inac} alt='icone' className={BEE ? 'ongletLOGOaléas_AC' : 'ongletLOGOaléas_INAC'}/> 
                        {BEE ? (<div className='paragrapheAleas'>Excès d'eau</div>) : ""}
                    </div>
                    <div className={BGEL ? 'paragraphe ongletaléas_INAC ongletaléas_AC OAléasGEL_AC': 'paragraphe ongletaléas_INAC OAléasGEL_INAC'} onClick={handleClickGEL}>   
                        <img src={BGEL ? GEL_ac: GEL_inac} alt='icone' className={BGEL ? 'ongletLOGOaléas_AC' : 'ongletLOGOaléas_INAC'}/> 
                        {BGEL ? (<div className='paragrapheAleas'>Gel</div>) : ""}
                    </div>
                    <div className={BCDC ? 'paragraphe ongletaléas_INAC ongletaléas_AC OAléasCDC_AC': 'paragraphe ongletaléas_INAC OAléasCDC_INAC'} onClick={handleClickCDC}> 
                        <img src={BCDC ? CDC_ac: CDC_inac} alt='icone' className={BCDC ? 'ongletLOGOaléas_AC' : 'ongletLOGOaléas_INAC'}/> 
                        {BCDC ? (<div className='paragrapheAleas'>Coup de chaleur</div>) : ""}
                    </div>
                    {/* <div className={BMR ? 'paragraphe ongletaléas_INAC ongletaléas_AC OAléasMR_AC': 'paragraphe ongletaléas_INAC OAléasMR_INAC'} onClick={handleClickMR}> 
                        <img src={BMR ? MR_ac: MR_inac} alt='icone'  className={BMR ? 'ongletLOGOaléas_AC' : 'ongletLOGOaléas_INAC'}/> 
                        {BMR ? (<div className='paragrapheAleas'>Manque de rayonnement</div>) : ""}
                    </div> */}
                    
                </div>

                {!BPodium ? dataMoy!== undefined && dataMax!== undefined && dataMin!== undefined && dataQ1!== undefined && dataQ3!== undefined  ? (
                  <div className='containerAleas'>
                    <div className='row'>
                      {/* <div className='titre' style={{width:'50%', textAlign:'center'}}>
                        Nombre de jour {BSH ? " de stress hydrique " : BEE ? " d'excès d'eau" : BGEL ? " de gel" : BCDC ? " de coup de chaleur": " du manque de rayonnement"}
                      </div> */}
                      <div className='titre' style={{width:'50%', textAlign:'center'}}>
                        Impact {BSH ? " du stress hydrique " : BEE ? " de l'excès d'eau" : BGEL ? " du gel" : BCDC ? " du coup de chaleur": " du manque de rayonnement"}
                      </div>
                    </div>
                    <div className='row'>
                      {/* <div style={{width:'50%'}}>
                        <GraphAleasNBjours2 myDataMoy={dataNbjoursMoy} myDataMax={dataNbjoursMax} myDataMin={dataNbjoursMin} aleas={aleas} dataType={TypeValeur}/>
                      </div> */}
                      <div style={{width:'70%'}}>
                        <GraphAleas2 myDataMoy={dataMoy} myDataMax={dataMax} myDataMin={dataMin} dataType={TypeValeur}/>
                      </div>
                    </div>

                    <div className='row PanelCommandeA'>
                      <div className='PanelCommandeAlea PCACulture'>
                        <div className='row' style={{width:'100%', justifyContent:'flex-start'}}>
                          <div className='titreMoins' style={{marginTop:'5px', marginLeft:'30px', width:'15%', textAlign:'start'}}> Cultures :</div>
                          <div className='row' onChange={handleChangeTypeCulture} style={{justifyContent:'flex-start',marginBottom:'0px', flexDirection:'column', alignItems:'flex-start', width:'100%'}}> 
                                <div className='row' style={{width:'100%'}}>
                                <div style={{width:'33%'}}>
                                  <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                      <input type="radio" value="none" name="CultureType" className='input_radio' defaultChecked={TypeCulture === "none"} style={{width:'20px', accentColor:'#D050B9'}} />  
                                      <div className='paragraphe texteCultureSolutions'> Toutes les cultures </div>
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="111" name="CultureType" className='input_radio' defaultChecked={TypeCulture === "111" } style={{width:'20px', accentColor:'#D050B9'}} disabled={culturePresente("Blé tendre", Assol)}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("Blé tendre", Assol) ? 'lightgray' : 'black' }}> Blé tendre </div> 
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="112" name="CultureType" className='input_radio' defaultChecked={TypeCulture === "112"} style={{width:'20px', accentColor:'#D050B9'}} disabled={culturePresente("Blé dur", Assol)}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("Blé dur", Assol) ? 'lightgray' : 'black' }}> Blé dur </div>
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="114" name="CultureType" className='input_radio' defaultChecked={TypeCulture === "114"} style={{width:'20px', accentColor:'#D050B9'}} disabled={culturePresente("Orge de printemps", Assol)}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("Orge de printemps", Assol) ? 'lightgray' : 'black' }}> Orge de printemps </div>
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="630" name="CultureType" className='input_radio' defaultChecked={TypeCulture === "630"} style={{width:'20px', accentColor:'#D050B9'}} disabled={culturePresente("AOP", Assol)}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("AOP", Assol) ? 'lightgray' : 'black' }}> Vignes AOP/AOC </div>
                                    </div>
                                </div>
                                <div style={{width:'33%'}}>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                      <input type="radio" value="115" name="CultureType" className='input_radio' defaultChecked={TypeCulture === "115"} style={{width:'20px', accentColor:'#D050B9'}} disabled={culturePresente("escourgeon", Assol)}/>  
                                      <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("escourgeon", Assol) ? 'lightgray' : 'black' }}> Orge d'hiver </div>
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="118" name="CultureType" className='input_radio' defaultChecked={TypeCulture === "118"} style={{width:'20px', accentColor:'#D050B9'}} disabled={culturePresente("Maïs", Assol)}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("Maïs", Assol) ? 'lightgray' : 'black' }}> Maïs </div>
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="213" name="CultureType" className='input_radio' defaultChecked={TypeCulture === "213"} style={{width:'20px', accentColor:'#D050B9'}} disabled={culturePresente("Betterave", Assol)}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("Betterave", Assol) ? 'lightgray' : 'black' }}> Betterave sucrière </div>
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="222" name="CultureType" className='input_radio' disabled={culturePresente("Colza", Assol)}  defaultChecked={TypeCulture === "222"} style={{width:'20px',accentColor:'#D050B9'}}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("Colza", Assol) ? 'lightgray' : 'black' }}> Colza </div>
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="670" name="CultureType" className='input_radio' defaultChecked={TypeCulture === "670"} style={{width:'20px', accentColor:'#D050B9'}} disabled={culturePresente("IGP", Assol)}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("IGP", Assol) ? 'lightgray' : 'black' }}> Vignes à vin IGP/ de pays </div>
                                    </div>
                                </div>
                                <div style={{width:'33%'}}>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="202" name="CultureType" className='input_radio' disabled={culturePresente("Pomme de terre", Assol)} defaultChecked={TypeCulture === "202"} style={{width:'20px',accentColor:'#D050B9'}}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("Pomme de terre", Assol) ? 'lightgray' : 'black' }}> Pomme de terre de conservation </div>
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="221" name="CultureType" className='input_radio' disabled={culturePresente("Tournesol", Assol)} defaultChecked={TypeCulture === "221"} style={{width:'20px', accentColor:'#D050B9'}}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("Tournesol", Assol) ? 'lightgray' : 'black' }}> Tournesol </div>
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="214" name="CultureType" className='input_radio' disabled defaultChecked={TypeCulture === "214"} style={{width:'20px', accentColor:'#D050B9'}}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{color:'lightgray'}}> Fève / fèverole </div>
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="217" name="CultureType" className='input_radio' disabled defaultChecked={TypeCulture === "217"} style={{width:'20px', accentColor:'#D050B9'}}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{color:'lightgray'}}> Pois protéagineux </div>
                                    </div>
                                    {/* <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="223" name="CultureType" className='input_radio' disabled defaultChecked={TypeCulture === "223"} style={{width:'20px', accentColor:'#D050B9'}}/>  
                                        <div className='paragraphe texteCultureSolutions' > Soja </div>
                                    </div> */}
                                    {/* <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="323" name="CultureType" className='input_radio' disabled defaultChecked={TypeCulture === "323"} style={{width:'20px', accentColor:'#D050B9'}}/>  
                                        <div className='paragraphe texteCultureSolutions' > Luzerne </div>
                                    </div>
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="231" name="CultureType" className='input_radio' disabled defaultChecked={TypeCulture === "231"} style={{width:'20px',accentColor:'#D050B9'}}/>  
                                        <div className='paragraphe texteCultureSolutions'> Chanvre </div> 
                                    </div> */}
                                    <div className='row' style={{justifyContent:'space-between',marginBottom:'0px', width:'100%'}}>
                                        <input type="radio" value="675" name="CultureType" className='input_radio' defaultChecked={TypeCulture === "675"} style={{width:'20px', accentColor:'#D050B9'}} disabled={culturePresente("VSIG", Assol)}/>  
                                        <div className='paragraphe texteCultureSolutions' style={{ color: culturePresente("VSIG", Assol) ? 'lightgray' : 'black' }}> Vignes à vin sans IG ou VSIG/ de table </div>
                                    </div>
                                </div>
                                </div>
                            </div> 
                        </div>
                      </div>
                      <div className='PanelCommandeAlea PCADonnes'>
                        <div className='titreMoins' style={{marginTop:'5px', marginLeft:'30px', width:'100%', textAlign:'start'}}> Données :</div>
                        <button onClick={SwitchDataType} className="validation paragraphe" style={{marginTop:'10px', marginLeft:'0px', marginBottom:'10px', width:'80%', height:'40px', backgroundColor : TypeValeur === "Valeur" ? '#ACE86B' : "white"}}>
                          Valeur
                        </button>
                        <button onClick={SwitchDataType}  className="validation paragraphe" style={{marginTop:'0px', marginLeft:'0px', marginBottom:'10px', width:'80%', height:'40px',padding:'0px', backgroundColor : TypeValeur === "Diff" ? '#ACE86B' : "white"}}>
                          Par rapport à 2020
                        </button>
                      </div>
                      <div className='PanelCommandeAlea PCADegre'>
                        <div className='titreMoins' style={{marginTop:'5px', marginLeft:'30px', width:'100%', textAlign:'start'}}> Modèle :</div>
                        <button className={B2d==='UnChecked' ? 'buttonResi buttonEntite buttonRCPCartesDefault rep buttonCarte' : 'buttonResi buttonEntite button2050degreChecked rep buttonCarte'} style={{width:'80%', height:'40px'}} onClick={handleB2D} >
                          2°C
                        </button>
                        <button className={B4d==='UnChecked' ? 'buttonResi buttonEntite buttonRCPCartesDefault rep buttonCarte' : 'buttonResi buttonEntite button2050degreChecked rep buttonCarte'} style={{width:'80%', height:'40px'}} onClick={handleB4D} >
                          4°C
                        </button>
                      </div>
                    </div>
                    
                  </div>
                ) : (
                  <div className='containerAleas'>
                      <div className='row' style={{marginTop:'100px'}}>
                        {/* <div style={{width:'50%'}}><img src={loading_Data} alt='icone'  className=""/></div> */}
                        <div style={{width:'50%'}}><img src={loading_Data} alt='icone'  className=""/></div>
                      </div>
                  </div>
                ) : (
                  <div className='containerAleas'>
                    <div className='principal' style={{marginTop:'10px', marginBottom:'30px'}}>
                      <div className='row AleasPodium'>
                        <button className={BCou==='UnChecked' ? 'buttonResi buttonEntite buttonRep7Default rep buttonCarte' : 'buttonResi buttonEntite buttonRep7Checked rep buttonCarte'} style={{width:'33%'}}   onClick={handlePressCourant} >
                          Courant
                        </button>
                        <button className={BExc==='UnChecked' ? 'buttonResi buttonEntite  buttonRep20Default rep buttonCarte' : 'buttonResi buttonEntite  buttonRep20Checked rep buttonCarte'} style={{width:'33%'}}  onClick={handlePressExceptionnel}>
                          Exceptionnel
                        </button>
                        <button className={BCat==='UnChecked' ? 'buttonResi buttonEntite  buttonRep50Default rep buttonCarte' : 'buttonResi buttonEntite  buttonRep50Checked rep buttonCarte'} style={{width:'33%'}}  onClick={handlePressCatastrophique}>
                          Catastrophique
                        </button>
                      </div>
                      <div className='AnneePodium'>
                        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                          <div className='paragraphe'>2025</div>
                          <div className='paragraphe'>2050</div>
                        </div>
                        <input style={{margin:'0px', height:'35px', width:'100%'}} type="range" id="cowbell" name="cowbell" min={2025} max={2050} value={ANNEE} step="5" onChange={handleChangeAnneeComp}/>
                        <div className='paragraphe' style={{marginLeft:ANNEE ==="2025" ? '0%' : ANNEE ==="2030" ? '15%' :  ANNEE ==="2035" ? "35%":  ANNEE ==="2040" ? "55%" :  ANNEE ==="2045" ? "75%" : "95%"}}> {ANNEE} </div>
                      </div>
                      <div className='row RCPPodium'>
                        <button className={B2d==='UnChecked' ? 'buttonResi buttonEntite buttonRCPCartesDefault rep buttonCarte' : 'buttonResi buttonEntite button2050degreChecked rep buttonCarte'}  onClick={handleB2D} >
                          2°C
                        </button>
                        <button className={B4d==='UnChecked' ? 'buttonResi buttonEntite buttonRCPCartesDefault rep buttonCarte' : 'buttonResi buttonEntite button2050degreChecked rep buttonCarte'}  onClick={handleB4D} >
                          4°C
                        </button>
                      </div>
                    </div>
                    {dataPodiumCA !== undefined ? (
                  <div className='row imagePodium PODIUMCA'> 
                    <div style={{display:'flex',justifyContent:'space-between', alignItems:'flex-start', width:'100%'}}>
                          {dataPodiumCA["2"] !== undefined ? ( 
                          <div className='elementspodium imagePodiumCA2'>
                            <div className='row'>
                              <img src={dataPodiumCA["2"][0]["alea"] === 'SH' ? SH_ac :dataPodiumCA["2"][0]["alea"] === 'EE' ? EE_ac :dataPodiumCA["2"][0]["alea"] === 'CDC' ? CDC_ac :dataPodiumCA["2"][0]["alea"] === 'GEL' ? GEL_ac :''} alt='icone'  className="imageAleaPodium" />
                              <img src={dataPodiumCA["2"][0]["culture"] === 1112 ||  dataPodiumCA["2"][0]["culture"] === 1113 ? BleT : dataPodiumCA["2"][0]["culture"] === 1122 ||  dataPodiumCA["2"][0]["culture"] === 1123 ? BleD : dataPodiumCA["2"][0]["culture"] === 114 ||  dataPodiumCA["2"][0]["culture"] === 115 ? Orge : dataPodiumCA["2"][0]["culture"] === 118 ? Mais : dataPodiumCA["2"][0]["culture"] === 222 ? Colza : (dataPodiumCA["2"][0]["culture"] === 630 || dataPodiumCA["2"][0]["culture"] === 670 || dataPodiumCA["2"][0]["culture"] === 675)? Viti : dataPodiumCA["2"][0]["culture"] === 221 ? Tournesol : dataPodiumCA["2"][0]["culture"] === 213 ? Betterave : dataPodiumCA["2"][0]["culture"] === 202 ? PdT : dataPodiumCA["2"][0]["culture"] === 323 ? Luzerne : dataPodiumCA["2"][0]["culture"] === 231 ? Chanvre : dataPodiumCA["2"][0]["culture"] === 223 ? Soja : dataPodiumCA["2"][0]["culture"] === 2142 ||  dataPodiumCA["2"][0]["culture"] === 2143 ? Feverole : dataPodiumCA["2"][0]["culture"] === 2172 ||  dataPodiumCA["2"][0]["culture"] === 2173 ? Pois :  ''} alt='icone'  className="imageAleaPodium" />
                            </div>
                            <div className='paragraphe'> {dataPodiumCA["2"][0]["alea"] === 'SH' ? "Stress hydrique" : dataPodiumCA["2"][0]["alea"] === 'EE' ? "Excès d'eau" : dataPodiumCA["2"][0]["alea"] === 'CDC' ? 'Coup de chaleur' : dataPodiumCA["2"][0]["alea"] === 'GEL' ? "Gel" : ''} / </div>
                            <div className='paragraphe'> {dataPodiumCA["2"][0]["culture"] === 1112 ? "Blé tendre de printemps" : dataPodiumCA["2"][0]["culture"] === 1113 ? "Blé tendre d'hiver" : dataPodiumCA["2"][0]["culture"] === 1122 ? "Blé dur de printemps" :  dataPodiumCA["2"][0]["culture"] === 1123 ? "Blé dur d'hiver" : dataPodiumCA["2"][0]["culture"] === 114 ? "Orge de printemps"  : dataPodiumCA["2"][0]["culture"] === 115 ? "Orge d'hiver" : dataPodiumCA["2"][0]["culture"] === 118 ? "Maïs" : dataPodiumCA["2"][0]["culture"] === 222 ? "Colza" : dataPodiumCA["2"][0]["culture"] === 630 ? "Viticulture AOC" : dataPodiumCA["2"][0]["culture"] === 670 ? "Viticulture IGP" : dataPodiumCA["2"][0]["culture"] === 675 ? "Viticulture VSIG" : dataPodiumCA["2"][0]["culture"] === 221 ? "Tournesol" : dataPodiumCA["2"][0]["culture"] === 213 ? "Betterave sucrière" : dataPodiumCA["2"][0]["culture"] === 202 ? "Pomme de terre" : dataPodiumCA["2"][0]["culture"] === 323 ? "Luzerne" : dataPodiumCA["2"][0]["culture"] === 231 ? "Chanvre" : dataPodiumCA["2"][0]["culture"] === 223 ? "Soja" : dataPodiumCA["2"][0]["culture"] === 2142 ? "Feverole de printemps" :  dataPodiumCA["2"][0]["culture"] === 2143 ? "Feverole d'hiver" : dataPodiumCA["2"][0]["culture"] === 2172 ? "Pois protéagineux de printemps" :  dataPodiumCA["2"][0]["culture"] === 2173 ?  "Pois protéagineux d'hiver" :  ''} </div>
                          </div>
                          ) : (
                            <div className='elementspodium imageVidePodiumCA2'>
                              <img  src={CultureNone} alt='icone'  className="imageAleaPodium"/>
                              <div className='paragraphe'> </div>
                              <div className='paragraphe'> </div>
                            </div> 
                          )}
                          <div className='elementspodium imagePodiumCA1' >
                            <div className='row'>
                              <img src={dataPodiumCA["1"][0]["alea"] === 'SH' ? SH_ac :dataPodiumCA["1"][0]["alea"] === 'EE' ? EE_ac :dataPodiumCA["1"][0]["alea"] === 'CDC' ? CDC_ac :dataPodiumCA["1"][0]["alea"] === 'GEL' ? GEL_ac :''} alt='icone'  className="imageAleaPodium" />
                              <img src={dataPodiumCA["1"][0]["culture"] === 1112 ||  dataPodiumCA["1"][0]["culture"] === 1113 ? BleT : dataPodiumCA["1"][0]["culture"] === 1122 ||  dataPodiumCA["1"][0]["culture"] === 1123 ? BleD : dataPodiumCA["1"][0]["culture"] === 114 ||  dataPodiumCA["1"][0]["culture"] === 115 ? Orge : dataPodiumCA["1"][0]["culture"] === 118 ? Mais : dataPodiumCA["1"][0]["culture"] === 222 ? Colza : (dataPodiumCA["1"][0]["culture"] === 630 || dataPodiumCA["1"][0]["culture"] === 670 || dataPodiumCA["1"][0]["culture"] === 675)? Viti : dataPodiumCA["1"][0]["culture"] === 221 ? Tournesol : dataPodiumCA["1"][0]["culture"] === 213 ? Betterave : dataPodiumCA["1"][0]["culture"] === 202 ? PdT : dataPodiumCA["1"][0]["culture"] === 323 ? Luzerne : dataPodiumCA["1"][0]["culture"] === 231 ? Chanvre : dataPodiumCA["1"][0]["culture"] === 223 ? Soja : dataPodiumCA["1"][0]["culture"] === 2142 ||  dataPodiumCA["1"][0]["culture"] === 2143 ? Feverole : dataPodiumCA["1"][0]["culture"] === 2172 ||  dataPodiumCA["1"][0]["culture"] === 2173 ? Pois :  ''} alt='icone'  className="imageAleaPodium" />
                            </div>
                            <div className='paragraphe'> {dataPodiumCA["1"][0]["alea"] === 'SH' ? "Stress hydrique" : dataPodiumCA["1"][0]["alea"] === 'EE' ? "Excès d'eau" : dataPodiumCA["1"][0]["alea"] === 'CDC' ? 'Coup de chaleur' : dataPodiumCA["1"][0]["alea"] === 'GEL' ? "Gel" : ''} / </div>
                            <div className='paragraphe'> {dataPodiumCA["1"][0]["culture"] === 1112 ? "Blé tendre de printemps" : dataPodiumCA["1"][0]["culture"] === 1113 ? "Blé tendre d'hiver" : dataPodiumCA["1"][0]["culture"] === 1122 ? "Blé dur de printemps" :  dataPodiumCA["1"][0]["culture"] === 1123 ? "Blé dur d'hiver" : dataPodiumCA["1"][0]["culture"] === 114 ? "Orge de printemps"  : dataPodiumCA["1"][0]["culture"] === 115 ? "Orge d'hiver" : dataPodiumCA["1"][0]["culture"] === 118 ? "Maïs" : dataPodiumCA["1"][0]["culture"] === 222 ? "Colza" : dataPodiumCA["1"][0]["culture"] === 630 ? "Viticulture AOC" : dataPodiumCA["1"][0]["culture"] === 670 ? "Viticulture IGP" : dataPodiumCA["1"][0]["culture"] === 675 ? "Viticulture VSIG" : dataPodiumCA["1"][0]["culture"] === 221 ? "Tournesol" : dataPodiumCA["1"][0]["culture"] === 213 ? "Betterave sucrière" : dataPodiumCA["1"][0]["culture"] === 202 ? "Pomme de terre" : dataPodiumCA["1"][0]["culture"] === 323 ? "Luzerne" : dataPodiumCA["1"][0]["culture"] === 231 ? "Chanvre" : dataPodiumCA["1"][0]["culture"] === 223 ? "Soja" : dataPodiumCA["1"][0]["culture"] === 2142 ? "Feverole de printemps" :  dataPodiumCA["1"][0]["culture"] === 2143 ? "Feverole d'hiver" : dataPodiumCA["1"][0]["culture"] === 2172 ? "Pois protéagineux de printemps" :  dataPodiumCA["1"][0]["culture"] === 2173 ?  "Pois protéagineux d'hiver" :  ''} </div>
                          </div>
                          {dataPodiumCA["3"] !== undefined ? ( 
                          <div className='elementspodium imagePodiumCA3' >
                            <div className='row'>
                              <img src={dataPodiumCA["3"][0]["alea"] === 'SH' ? SH_ac :dataPodiumCA["3"][0]["alea"] === 'EE' ? EE_ac :dataPodiumCA["3"][0]["alea"] === 'CDC' ? CDC_ac :dataPodiumCA["3"][0]["alea"] === 'GEL' ? GEL_ac :''} alt='icone'  className="imageAleaPodium" />
                              <img src={dataPodiumCA["3"][0]["culture"] === 1112 ||  dataPodiumCA["3"][0]["culture"] === 1113 ? BleT : dataPodiumCA["3"][0]["culture"] === 1122 ||  dataPodiumCA["3"][0]["culture"] === 1123 ? BleD : dataPodiumCA["3"][0]["culture"] === 114 ||  dataPodiumCA["3"][0]["culture"] === 115 ? Orge : dataPodiumCA["3"][0]["culture"] === 118 ? Mais : dataPodiumCA["3"][0]["culture"] === 222 ? Colza : (dataPodiumCA["3"][0]["culture"] === 630 || dataPodiumCA["3"][0]["culture"] === 670 || dataPodiumCA["3"][0]["culture"] === 675)? Viti : dataPodiumCA["3"][0]["culture"] === 221 ? Tournesol : dataPodiumCA["3"][0]["culture"] === 213 ? Betterave : dataPodiumCA["3"][0]["culture"] === 202 ? PdT : dataPodiumCA["3"][0]["culture"] === 323 ? Luzerne : dataPodiumCA["3"][0]["culture"] === 231 ? Chanvre : dataPodiumCA["3"][0]["culture"] === 223 ? Soja : dataPodiumCA["3"][0]["culture"] === 2142 ||  dataPodiumCA["3"][0]["culture"] === 2143 ? Feverole : dataPodiumCA["3"][0]["culture"] === 2172 ||  dataPodiumCA["3"][0]["culture"] === 2173 ? Pois :  ''} alt='icone'  className="imageAleaPodium" />
                            </div>
                            <div className='paragraphe'> {dataPodiumCA["3"][0]["alea"] === 'SH' ? "Stress hydrique" : dataPodiumCA["3"][0]["alea"] === 'EE' ? "Excès d'eau" : dataPodiumCA["3"][0]["alea"] === 'CDC' ? 'Coup de chaleur' : dataPodiumCA["3"][0]["alea"] === 'GEL' ? "Gel" : ''} /</div>
                            <div className='paragraphe'> {dataPodiumCA["3"][0]["culture"] === 1112 ? "Blé tendre de printemps" : dataPodiumCA["3"][0]["culture"] === 1113 ? "Blé tendre d'hiver" : dataPodiumCA["3"][0]["culture"] === 1122 ? "Blé dur de printemps" :  dataPodiumCA["3"][0]["culture"] === 1123 ? "Blé dur d'hiver" : dataPodiumCA["3"][0]["culture"] === 114 ? "Orge de printemps"  : dataPodiumCA["3"][0]["culture"] === 115 ? "Orge d'hiver" : dataPodiumCA["3"][0]["culture"] === 118 ? "Maïs" : dataPodiumCA["3"][0]["culture"] === 222 ? "Colza" : dataPodiumCA["3"][0]["culture"] === 630 ? "Viticulture AOC" : dataPodiumCA["3"][0]["culture"] === 670 ? "Viticulture IGP" : dataPodiumCA["3"][0]["culture"] === 675 ? "Viticulture VSIG" : dataPodiumCA["3"][0]["culture"] === 221 ? "Tournesol" : dataPodiumCA["3"][0]["culture"] === 213 ? "Betterave sucrière" : dataPodiumCA["3"][0]["culture"] === 202 ? "Pomme de terre" : dataPodiumCA["3"][0]["culture"] === 323 ? "Luzerne" : dataPodiumCA["3"][0]["culture"] === 231 ? "Chanvre" : dataPodiumCA["3"][0]["culture"] === 223 ? "Soja" : dataPodiumCA["3"][0]["culture"] === 2142 ? "Feverole de printemps" :  dataPodiumCA["3"][0]["culture"] === 2143 ? "Feverole d'hiver" : dataPodiumCA["3"][0]["culture"] === 2172 ? "Pois protéagineux de printemps" :  dataPodiumCA["3"][0]["culture"] === 2173 ?  "Pois protéagineux d'hiver" :  ''} </div>
                          </div> 
                          ) : (
                            <div className='elementspodium imageVidePodiumCA3'>
                              <img  src={CultureNone} alt='icone'  className="imageAleaPodium"/>
                              <div className='paragraphe'> </div>
                            </div> 
                          )}
                        </div>
                      <div className='row RDTPodiumCA' >
                      <div className='paragraphe' style={{width:'30%'}}> {dataPodiumCA['2']!== undefined ?dataPodiumCA["2"][0]["perte"]: "/"} % </div>
                      <div className='paragraphe' style={{width:'30%'}}> {dataPodiumCA["1"][0]["perte"]} % </div>
                      <div className='paragraphe' style={{width:'30%'}}> {dataPodiumCA["3"] !== undefined ? dataPodiumCA["3"][0]["perte"] : "/"} % </div>
                      </div>
                      <div className='titreMoins titrePodium'> Aléa et culture </div>
                    </div> 
                    ) : (
                      <div className='containerAleas'>
                        <div className='row' style={{marginTop:'100px'}}>
                          <img src={loading_Data} alt='icone'  className=""/>
                        </div>
                      </div>
                    )}
                    {dataPodiumC !== undefined && dataPodiumA !== undefined ? (
                    <div className='principal rowPODIUMCouA'>
                      <div className='row imagePodium PODIUMCouA'> 
                      <div style={{display:'flex',justifyContent:'space-between', alignItems:'flex-start', width:'100%'}}>
                        {dataPodiumC["2"] !== undefined ? ( 
                        <div className='elementspodium imagePodium_C_ou_A_2'>
                          <img src={dataPodiumC["2"][0]["culture"] === 1112 ||  dataPodiumC["2"][0]["culture"] === 1113 ? BleT : dataPodiumC["2"][0]["culture"] === 1122 ||  dataPodiumC["2"][0]["culture"] === 1123 ? BleD : dataPodiumC["2"][0]["culture"] === 114 ||  dataPodiumC["2"][0]["culture"] === 115 ? Orge : dataPodiumC["2"][0]["culture"] === 118 ? Mais : dataPodiumC["2"][0]["culture"] === 222 ? Colza : (dataPodiumC["2"][0]["culture"] === 630 || dataPodiumC["2"][0]["culture"] === 670 || dataPodiumC["2"][0]["culture"] === 675)? Viti : dataPodiumC["2"][0]["culture"] === 221 ? Tournesol : dataPodiumC["2"][0]["culture"] === 213 ? Betterave : dataPodiumC["2"][0]["culture"] === 202 ? PdT : dataPodiumC["2"][0]["culture"] === 323 ? Luzerne : dataPodiumC["2"][0]["culture"] === 231 ? Chanvre : dataPodiumC["2"][0]["culture"] === 223 ? Soja : dataPodiumC["2"][0]["culture"] === 2142 ||  dataPodiumC["2"][0]["culture"] === 2143 ? Feverole : dataPodiumC["2"][0]["culture"] === 2172 ||  dataPodiumC["2"][0]["culture"] === 2173 ? Pois :  ''} alt='icone'  className="imageAleaPodium" />
                          <div className='paragraphe'> {dataPodiumC["2"][0]["culture"] === 1112 ? "Blé tendre de printemps" : dataPodiumC["2"][0]["culture"] === 1113 ? "Blé tendre d'hiver" : dataPodiumC["2"][0]["culture"] === 1122 ? "Blé dur de printemps" :  dataPodiumC["2"][0]["culture"] === 1123 ? "Blé dur d'hiver" : dataPodiumC["2"][0]["culture"] === 114 ? "Orge de printemps"  : dataPodiumC["2"][0]["culture"] === 115 ? "Orge d'hiver" : dataPodiumC["2"][0]["culture"] === 118 ? "Maïs" : dataPodiumC["2"][0]["culture"] === 222 ? "Colza" : dataPodiumC["2"][0]["culture"] === 630 ? "Viticulture AOC" : dataPodiumC["2"][0]["culture"] === 670 ? "Viticulture IGP" : dataPodiumC["2"][0]["culture"] === 675 ? "Viticulture VSIG" : dataPodiumC["2"][0]["culture"] === 221 ? "Tournesol" : dataPodiumC["2"][0]["culture"] === 213 ? "Betterave sucrière" : dataPodiumC["2"][0]["culture"] === 202 ? "Pomme de terre" : dataPodiumC["2"][0]["culture"] === 323 ? "Luzerne" : dataPodiumC["2"][0]["culture"] === 231 ? "Chanvre" : dataPodiumC["2"][0]["culture"] === 223 ? "Soja" : dataPodiumC["2"][0]["culture"] === 2142 ? "Feverole de printemps" :  dataPodiumC["2"][0]["culture"] === 2143 ? "Feverole d'hiver" : dataPodiumC["2"][0]["culture"] === 2172 ? "Pois protéagineux de printemps" :  dataPodiumC["2"][0]["culture"] === 2173 ?  "Pois protéagineux d'hiver" :  ''} </div>
                        </div>
                        ) : (
                          <div className='elementspodium imageVidePodium_C_ou_A_2'>
                            <img  src={CultureNone} alt='icone'  className="imageAleaPodium"/>
                            <div className='paragraphe'> </div>
                          </div> 
                        )}
                        <div className='elementspodium imagePodium_C_ou_A_1'> 
                          <img src={dataPodiumC["1"][0]["culture"] === 1112 ||  dataPodiumC["1"][0]["culture"] === 1113 ? BleT : dataPodiumC["1"][0]["culture"] === 1122 ||  dataPodiumC["1"][0]["culture"] === 1123 ? BleD : dataPodiumC["1"][0]["culture"] === 114 ||  dataPodiumC["1"][0]["culture"] === 115 ? Orge : dataPodiumC["1"][0]["culture"] === 118 ? Mais : dataPodiumC["1"][0]["culture"] === 222 ? Colza : (dataPodiumC["1"][0]["culture"] === 630 || dataPodiumC["1"][0]["culture"] === 670 || dataPodiumC["1"][0]["culture"] === 675)? Viti : dataPodiumC["1"][0]["culture"] === 221 ? Tournesol : dataPodiumC["1"][0]["culture"] === 213 ? Betterave : dataPodiumC["1"][0]["culture"] === 202 ? PdT : dataPodiumC["1"][0]["culture"] === 323 ? Luzerne : dataPodiumC["1"][0]["culture"] === 231 ? Chanvre : dataPodiumC["1"][0]["culture"] === 223 ? Soja : dataPodiumC["1"][0]["culture"] === 2142 ||  dataPodiumC["1"][0]["culture"] === 2143 ? Feverole : dataPodiumC["1"][0]["culture"] === 2172 ||  dataPodiumC["1"][0]["culture"] === 2173 ? Pois :  ''} alt='icone'  className="imageAleaPodium" />
                          <div className='paragraphe'> {dataPodiumC["1"][0]["culture"] === 1112 ? "Blé tendre de printemps" : dataPodiumC["1"][0]["culture"] === 1113 ? "Blé tendre d'hiver" : dataPodiumC["1"][0]["culture"] === 1122 ? "Blé dur de printemps" :  dataPodiumC["1"][0]["culture"] === 1123 ? "Blé dur d'hiver" : dataPodiumC["1"][0]["culture"] === 114 ? "Orge de printemps"  : dataPodiumC["1"][0]["culture"] === 115 ? "Orge d'hiver" : dataPodiumC["1"][0]["culture"] === 118 ? "Maïs" : dataPodiumC["1"][0]["culture"] === 222 ? "Colza" : dataPodiumC["1"][0]["culture"] === 630 ? "Viticulture AOC" : dataPodiumC["1"][0]["culture"] === 670 ? "Viticulture IGP" : dataPodiumC["1"][0]["culture"] === 675 ? "Viticulture VSIG" : dataPodiumC["1"][0]["culture"] === 221 ? "Tournesol" : dataPodiumC["1"][0]["culture"] === 213 ? "Betterave sucrière" : dataPodiumC["1"][0]["culture"] === 202 ? "Pomme de terre" : dataPodiumC["1"][0]["culture"] === 323 ? "Luzerne" : dataPodiumC["1"][0]["culture"] === 231 ? "Chanvre" : dataPodiumC["1"][0]["culture"] === 223 ? "Soja" : dataPodiumC["1"][0]["culture"] === 2142 ? "Feverole de printemps" :  dataPodiumC["1"][0]["culture"] === 2143 ? "Feverole d'hiver" : dataPodiumC["1"][0]["culture"] === 2172 ? "Pois protéagineux de printemps" :  dataPodiumC["1"][0]["culture"] === 2173 ?  "Pois protéagineux d'hiver" :  ''} </div>
                        </div>
                        {dataPodiumC["3"] !== undefined ? ( 
                        <div className='elementspodium imagePodium_C_ou_A_3'>
                          <img src={dataPodiumC["3"][0]["culture"] === 1112 ||  dataPodiumC["3"][0]["culture"] === 1113 ? BleT : dataPodiumC["3"][0]["culture"] === 1122 ||  dataPodiumC["3"][0]["culture"] === 1123 ? BleD : dataPodiumC["3"][0]["culture"] === 114 ||  dataPodiumC["3"][0]["culture"] === 115 ? Orge : dataPodiumC["3"][0]["culture"] === 118 ? Mais : dataPodiumC["3"][0]["culture"] === 222 ? Colza : (dataPodiumC["3"][0]["culture"] === 630 || dataPodiumC["3"][0]["culture"] === 670 || dataPodiumC["3"][0]["culture"] === 675)? Viti : dataPodiumC["3"][0]["culture"] === 221 ? Tournesol : dataPodiumC["3"][0]["culture"] === 213 ? Betterave : dataPodiumC["3"][0]["culture"] === 202 ? PdT : dataPodiumC["3"][0]["culture"] === 323 ? Luzerne : dataPodiumC["3"][0]["culture"] === 231 ? Chanvre : dataPodiumC["3"][0]["culture"] === 223 ? Soja : dataPodiumC["3"][0]["culture"] === 2142 ||  dataPodiumC["3"][0]["culture"] === 2143 ? Feverole : dataPodiumC["3"][0]["culture"] === 2172 ||  dataPodiumC["3"][0]["culture"] === 2173 ? Pois :  ''} alt='icone'  className="imageAleaPodium" />
                          <div className='paragraphe'> {dataPodiumC["3"][0]["culture"] === 1112 ? "Blé tendre de printemps" : dataPodiumC["3"][0]["culture"] === 1113 ? "Blé tendre d'hiver" : dataPodiumC["3"][0]["culture"] === 1122 ? "Blé dur de printemps" :  dataPodiumC["3"][0]["culture"] === 1123 ? "Blé dur d'hiver" : dataPodiumC["3"][0]["culture"] === 114 ? "Orge de printemps"  : dataPodiumC["3"][0]["culture"] === 115 ? "Orge d'hiver" : dataPodiumC["3"][0]["culture"] === 118 ? "Maïs" : dataPodiumC["3"][0]["culture"] === 222 ? "Colza" : dataPodiumC["3"][0]["culture"] === 630 ? "Viticulture AOC" : dataPodiumC["3"][0]["culture"] === 670 ? "Viticulture IGP" : dataPodiumC["3"][0]["culture"] === 675 ? "Viticulture VSIG" : dataPodiumC["3"][0]["culture"] === 221 ? "Tournesol" : dataPodiumC["3"][0]["culture"] === 213 ? "Betterave sucrière" : dataPodiumC["3"][0]["culture"] === 202 ? "Pomme de terre" : dataPodiumC["3"][0]["culture"] === 323 ? "Luzerne" : dataPodiumC["3"][0]["culture"] === 231 ? "Chanvre" : dataPodiumC["3"][0]["culture"] === 223 ? "Soja" : dataPodiumC["3"][0]["culture"] === 2142 ? "Feverole de printemps" :  dataPodiumC["3"][0]["culture"] === 2143 ? "Feverole d'hiver" : dataPodiumC["3"][0]["culture"] === 2172 ? "Pois protéagineux de printemps" :  dataPodiumC["3"][0]["culture"] === 2173 ?  "Pois protéagineux d'hiver" :  ''} </div>
                        </div> 
                        ) : (
                          <div className='elementspodium imageVidePodium_C_ou_A_3'>
                            <img  src={CultureNone} alt='icone'  className="imageAleaPodium"/>
                            <div className='paragraphe'> </div>
                          </div> 
                        )}
                      </div>
                      <div className='row RDTPodium_C_ou_A'>
                        <div className='paragraphe' style={{width:'30%'}}> {dataPodiumC['2']!== undefined ?dataPodiumC["2"][0]["perte"]: "/"} % </div>
                        <div className='paragraphe' style={{width:'30%'}}> {dataPodiumC["1"][0]["perte"]} % </div>
                        <div className='paragraphe' style={{width:'30%'}}> {dataPodiumC["3"] !== undefined ? dataPodiumC["3"][0]["perte"] : "/"} % </div>
                      </div>
                      <div className='titreMoins titrePodium'> Cultures </div>
                    </div> 

                    <div className='row imagePodium PODIUMCouA'> 
                      <div style={{display:'flex',justifyContent:'space-between', alignItems:'flex-start', width:'100%'}}>
                        {dataPodiumA["2"] !== undefined ? ( 
                        <div className='elementspodium imagePodium_C_ou_A_2' >
                          <img src={dataPodiumA["2"][0]["alea"] === 'SH' ? SH_ac :dataPodiumA["2"][0]["alea"] === 'EE' ? EE_ac :dataPodiumA["2"][0]["alea"] === 'CDC' ? CDC_ac :dataPodiumA["2"][0]["alea"] === 'GEL' ? GEL_ac :''} alt='icone'  className="imageAleaPodium" />
                          <div className='paragraphe'> {dataPodiumA["2"][0]["alea"] === 'SH' ? "Stress hydrique" : dataPodiumA["2"][0]["alea"] === 'EE' ? "Excès d'eau" : dataPodiumA["2"][0]["alea"] === 'CDC' ? 'Coup de chaleur' : dataPodiumA["2"][0]["alea"] === 'GEL' ? "Gel" : ''} </div>
                        </div>
                        ) : (
                          <div className='elementspodium imageVidePodium_C_ou_A_2'>
                            <img  src={CultureNone} alt='icone'  className="imageAleaPodium" />
                            <div className='paragraphe'> </div>
                          </div> 
                        )}
                        <div className='elementspodium imagePodium_C_ou_A_1'>
                          <img src={dataPodiumA["1"][0]["alea"] === 'SH' ? SH_ac :dataPodiumA["1"][0]["alea"] === 'EE' ? EE_ac :dataPodiumA["1"][0]["alea"] === 'CDC' ? CDC_ac :dataPodiumA["1"][0]["alea"] === 'GEL' ? GEL_ac :''} alt='icone'  className="imageAleaPodium" />
                          <div className='paragraphe'> {dataPodiumA["1"][0]["alea"] === 'SH' ? "Stress hydrique" : dataPodiumA["1"][0]["alea"] === 'EE' ? "Excès d'eau" : dataPodiumA["1"][0]["alea"] === 'CDC' ? 'Coup de chaleur' : dataPodiumA["1"][0]["alea"] === 'GEL' ? "Gel" : ''} </div>
                        </div>
                        {dataPodiumA["3"] !== undefined ? ( 
                        <div className='elementspodium imagePodium_C_ou_A_3'>
                          <img src={dataPodiumA["3"][0]["alea"] === 'SH' ? SH_ac :dataPodiumA["3"][0]["alea"] === 'EE' ? EE_ac :dataPodiumA["3"][0]["alea"] === 'CDC' ? CDC_ac :dataPodiumA["3"][0]["alea"] === 'GEL' ? GEL_ac :''} alt='icone'  className="imageAleaPodium" />
                          <div className='paragraphe'> {dataPodiumA["3"][0]["alea"] === 'SH' ? "Stress hydrique" : dataPodiumA["3"][0]["alea"] === 'EE' ? "Excès d'eau" : dataPodiumA["3"][0]["alea"] === 'CDC' ? 'Coup de chaleur' : dataPodiumA["3"][0]["alea"] === 'GEL' ? "Gel" : ''} </div>
                        </div>  
                        ) : (
                          <div className='elementspodium imageVidePodium_C_ou_A_3'>
                            <img  src={CultureNone} alt='icone'  className="imageAleaPodium" />
                            <div className='paragraphe'> </div>
                          </div> 
                        )}
                        </div>
                        <div className='row RDTPodium_C_ou_A'>
                          <div className='paragraphe' style={{width:'30%'}}> {dataPodiumA['2']!== undefined ?dataPodiumA["2"][0]["perte"]: "/"} % </div>
                          <div className='paragraphe' style={{width:'30%'}}> {dataPodiumA["1"][0]["perte"]} % </div>
                          <div className='paragraphe' style={{width:'30%'}}> {dataPodiumA["3"] !== undefined ? dataPodiumA["3"][0]["perte"] : "/"} % </div>
                        </div>
                      <div className='titreMoins titrePodium'> Aléas </div>
                    </div> 
                  </div>
                  ) : (
                    <div className='containerAleas'>
                      <div className='row' style={{marginTop:'100px'}}>
                        <img src={loading_Data} alt='icone'  className=""/>
                      </div>
                      <div className='row' style={{marginTop:'100px'}}>
                        <img src={loading_Data} alt='icone'  className=""/>
                      </div>
                    </div>
                  )}
                  
                </div>
                )}
            </div>
            <ButtonQuestions/>
            <OADMenu idExploit={idExploit}/>
        </div>
    )
}

export default Aleas